const isCartDrawer = document
  .querySelector("#settingsCartDrawer")
  .innerText.trim()
  .split(",");

const isAvailableCartDrawer = isCartDrawer.includes(window.location.pathname);

class CartUpdateDrawer extends HTMLElement {
  constructor() {
    super();
    if (!isAvailableCartDrawer) {
      this.cartLayer = document.querySelector(".drawer__cart-section");
      this.overflow = document.querySelector("html");
      this.fetchRequest = false;
      if (document.querySelector(".cart-icon").href === "") {
        this.cartInteraction = this.cartInteraction.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.init();
      }
    }
    this.addEventListener("render", this.render.bind(this));
  }

  render() {
    this.cartUpsellInit();
    this.cartUpdate();
    this.openCartDrawer();
  }

  init() {
    const icon = document.querySelector(".cart-icon");
    if (icon && icon.href === "") {
      document.body.addEventListener("click", this.handleClickOutside);
      icon.addEventListener("click", this.cartInteraction);
    }
  }
  connectedCallback() {
    this.cartUpsellInit();
  }
  cartUpsellInit() {
    if (
      document
        .querySelector(
          ".drawer-product-recommendations-wrapper .swiper-wrapper"
        )
        ?.innerText?.trim() === ""
    ) {
      document
        .querySelector(".drawer-product-recommendations-wrapper")
        .remove();
      return;
    }
    document.querySelectorAll(".cart-upsell-wrapper")?.forEach((item) => {
      const slides = item.querySelectorAll(".swiper-slide");

      if (slides.length > 0) {
        Array.from(slides)
          .sort(({ dataset: { position: a } }, { dataset: { position: b } }) =>
            b.localeCompare(a)
          )
          .forEach((item) => item.parentNode.appendChild(item));

        if (typeof Swiper !== "undefined") {
          new Swiper(".cart-recommendation", {
            loop: false,
            slidesPerView: 4,
            spaceBetween: 30,
            breakpoints: {
              300: {
                slidesPerView: 1.3,
                spaceBetween: 10,
              },
              400: {
                slidesPerView: 1.3,
                spaceBetween: 30,
              },
            },
          });
        }
      }
    });
  }
  disconnectedCallback() {
    const icon = document.querySelector(".cart-icon");
    if (icon && icon.href === "") {
      document.body.removeEventListener("click", this.handleClickOutside);
      icon.removeEventListener("click", this.cartInteraction);
    }
  }

  handleClickOutside(event) {
    const cartDrawer = document.getElementById("cart-drawer");
    const isOutside =
      !cartDrawer.contains(event.target) &&
      !event.target.classList.contains("cart-icon");
    const isCloseButton = event.target.classList.contains("close-cart-drawer");

    if (isOutside || isCloseButton) {
      this.closeCartDrawer();
    }
  }

  cartInteraction(event) {
    event.stopPropagation();
    this.openCartDrawer();

    if (!document.querySelectorAll(".quantity-input").length) {
      this.emptyCart();
    } else {
      this.cartUpdate();
    }
  }

  emptyCart() {
    const cartItems = document.querySelector(".cart-items")?.innerHTML;
    if (!cartItems) {
      fetch("/?sections=cart-drawer")
        .then((response) => response.json())
        .then((data) => {
          const parser = new DOMParser();
          const html = parser.parseFromString(data["cart-drawer"], "text/html");
          document.querySelector(".cart-drawer-content").innerHTML =
            html.querySelector(".cart-drawer-content").innerHTML;
          this.cartUpsellInit();
        });
      const dataCartCount = document.querySelector("[data-cart-counter]");
      dataCartCount.classList.add("hidden");
      //dataCartCount.textContent = cartCount.value;
    } else {
      this.cartUpdate();
    }
  }

  openCartDrawer() {
    document.querySelector("#cart-drawer").classList.add("activeMenu");
    document.body.classList.add("activeMenu");
    this.cartLayer.classList.add("cart-drawer__overlay");
    this.overflow.style.overflow = "hidden";
  }

  closeCartDrawer() {
    document.querySelector("#cart-drawer").classList.remove("activeMenu");
    document.body.classList.remove("activeMenu");
    this.cartLayer.classList.remove("cart-drawer__overlay");
    this.overflow.style.overflow = "";
  }

  cartUpdate() {
    const quantityInputs = document.querySelectorAll(".quantity-input");
    if (!quantityInputs.length) {
      this.emptyCart();
      return;
    }

    this.setupQuantityHandlers(quantityInputs);
    this.setupRemoveHandlers(quantityInputs);
  }

  setupQuantityHandlers(quantityInputs) {
    document.querySelectorAll(".quantity-decrease").forEach((btn, i) => {
      btn.replaceWith(btn.cloneNode(true));
    });
    document.querySelectorAll(".quantity-increase").forEach((btn, i) => {
      btn.replaceWith(btn.cloneNode(true));
    });

    document.querySelectorAll(".quantity-decrease").forEach((btn, i) => {
      btn.addEventListener("click", () => {
        if (quantityInputs[i].value >= 0) {
          quantityInputs[i].value--;
          this.fetchRequest = true;
          quantityInputs[i].dispatchEvent(
            new Event("change", { bubbles: true })
          );
        }
      });
    });

    document.querySelectorAll(".quantity-increase").forEach((btn, i) => {
      btn.addEventListener("click", () => {
        quantityInputs[i].value++;
        this.fetchRequest = true;
        quantityInputs[i].dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    quantityInputs.forEach((input) => {
      input.addEventListener("change", async () => {
        await this.updateCartItem(input);
      });
    });
  }

  async updatesDiscountProducts(updates, discount = "") {
    const quantityInputs = document.querySelectorAll(".quantity-input");
    quantityInputs.forEach((inp) => {
      const form = inp.closest("form");
      if (form) {
        form.style.pointerEvents = "none";
        form.style.opacity = "0.5";
      }
    });
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify({ updates, discount }),
      });
      if (!response.ok) throw new Error("Failed to update the cart.");

      const cartDrawerResponse = await fetch(`/?sections=cart-drawer`);
      const cartDrawerData = await cartDrawerResponse.json();
      this.drawCart(cartDrawerData);

    } catch (error) {
      quantityInputs.forEach((inp) => {
        const form = inp.closest("form");
        if (form) {
          form.style.pointerEvents = "auto";
          form.style.opacity = "1";
        }
      });
      this.fetchRequest = false;
    }
  }
  async updateCartItem(input) {
    const productId = input.getAttribute("cart-item-key");
    const quantity = input.value;
    const updates = { [`${productId}`]: +quantity };
    const quantityInputs = document.querySelectorAll(".quantity-input");

    if (!this.fetchRequest) return;

    quantityInputs.forEach((inp) => {
      const form = inp.closest("form");
      if (form) {
        form.style.pointerEvents = "none";
        form.style.opacity = "0.5";
      }
    });

    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify({ updates }),
      });
      if (!response.ok) throw new Error("Failed to update the cart.");

      const cartDrawerResponse = await fetch(`/?sections=cart-drawer`);
      const cartDrawerData = await cartDrawerResponse.json();
      this.drawCart(cartDrawerData);
      this.checkDiscount();
    } catch (err) {
      console.error("Update error:", err);
    } finally {
      // Re-enable all forms after update
      quantityInputs.forEach((inp) => {
        const form = inp.closest("form");
        if (form) {
          form.style.pointerEvents = "auto";
          form.style.opacity = "1";
        }
      });
      this.fetchRequest = false;
    }
  }
  getChangeLineItemMutations() {
    return Array.from(
      document.querySelectorAll('script[data-json="changeLineItem"]')
    ).reduce((changeLineItems, item) => {
      try {
        const dataJson = JSON.parse(item.textContent);
        changeLineItems.push(dataJson);
      } catch {
        console.warn("ChangeLineItem data parsing is failed");
      }
      return changeLineItems;
    }, []);
  }
  getAddLineItemMutations() {
    return Array.from(
      document.querySelectorAll('script[data-json="addLineItem"]')
    ).reduce((addLineItems, item) => {
      try {
        const dataJson = JSON.parse(item.textContent);
        addLineItems.push(dataJson);
      } catch {
        console.warn("AddLineItem data parsing is failed");
      }
      return addLineItems;
    }, []);
  }
  checkDiscount() {
    const changeLineItems = Array.from(
      new Set(this.getChangeLineItemMutations().map((p) => JSON.stringify(p)))
    ).map((p) => JSON.parse(p));

    const addLineItems = Array.from(
      new Set(this.getAddLineItemMutations().map((p) => JSON.stringify(p)))
    ).map((p) => JSON.parse(p));

    let discounts = [];
    if (changeLineItems.length) {
      const deleteDiscount = [];
      const updates = changeLineItems.reduce((acc, val) => {
        acc[val.id] = val.quantity;
        deleteDiscount.push(val.discount)
        return acc;
      }, {});
      
      discounts = [...document.querySelectorAll('.cart-line-item__discount[data-discount-codes]')].reduce((acc,val) => {
        const code = val.getAttribute('data-discount-codes');
        if(!deleteDiscount.includes(code)) {
         acc.push(code)
        }
        return acc
      },[]).join(',')
    
      this.updatesDiscountProducts(updates,discounts);

    }
    if(addLineItems.length) {
      const updates = addLineItems.reduce((acc, val) => {
        acc[val.id] = val.quantity;
        discounts.push(val.discount)
        return acc;
      }, {});
      discounts = discounts.join(',')
      this.updatesDiscountProducts(updates,discounts);
    }
  }

  setupRemoveHandlers(quantityInputs) {
    document.querySelectorAll(".remove-cart-item").forEach((btn, i) => {
      btn.replaceWith(btn.cloneNode(true));
    });

    document.querySelectorAll(".remove-cart-item").forEach((btn, i) => {
      btn.addEventListener("click", () => {
        quantityInputs[i].value = 0;
        this.fetchRequest = true;
        quantityInputs[i].dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  }

  drawCart(data) {
    const newDrawer = data["cart-drawer"];
    const parser = new DOMParser();
    const tempDiv = parser.parseFromString(newDrawer, "text/html");
    if (
      tempDiv
        .querySelector(
          ".cart-drawer-content .cart-recommendation .swiper-wrapper"
        )
        ?.innerText?.trim() === ""
    ) {
      tempDiv.querySelector(".drawer-product-recommendations-wrapper").remove();
    }
    const header = tempDiv.querySelector(".cart-drawer-header ");
    const content = tempDiv.querySelector(".cart-drawer-content");
    const cartCount = tempDiv.querySelector("#updateCartCount");
    const dataCartCount = document.querySelector("[data-cart-counter]");
    const cartDrawer = document.getElementById("cart-drawer");

    if (dataCartCount && cartCount) {
      if (dataCartCount.classList.contains("hidden")) {
        dataCartCount.classList.remove("hidden");
      }
      if (cartCount.value == 0) {
        dataCartCount.classList.add("hidden");
      }
      dataCartCount.textContent = cartCount?.value;
    }

    if (cartDrawer && (header || content)) {
      cartDrawer.innerHTML = "";
      if (header) cartDrawer.appendChild(header);
      if (content) cartDrawer.appendChild(content);
    }
    this.cartUpsellInit();
    this.cartUpdate();
  }

  async drawerUpdate() {
    const cartDrawerResponse = await fetch(`/?sections=cart-drawer`);
    const cartDrawerData = await cartDrawerResponse.json();
    this.drawCart(cartDrawerData);
    this.checkDiscount();
    this.cartUpsellInit();
    this.cartUpdate();
  }
}

customElements.define("cart-update-drawer", CartUpdateDrawer);